// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__FOwjt","profileInfo":"profile_profileInfo__14Mlr","name":"profile_name__3H8Dj","lastChild":"profile_lastChild__1Kx-5","offset":"profile_offset__EiQeb"};